export default "__VITE_ASSET__Kd2EXCA0__"